'use strict';

/* global angular */

const AppDialogsController = function(
    $scope, $rootScope, $window, $state, $sce, $timeout, $location, Flux, SaturnGrowl,
    AppDialogsActions, SiteStore, SiteActions, IdentityService, AnalyticsService
) {

  const vm = this;
  const PlanStore = Flux.Store.get('PlanStore');

  vm.position = 'center';
  vm.alignment = 'top right';
  vm.PRICING_PAGE_STRING = 'https://s3-us-west-2.amazonaws.com/assets.skycatch.com/pages/pricing.tpl.html';

  if (PlanStore.get('orgPlan') && PlanStore.get('orgPlan').name) {
    vm.PRICING_PAGE = $sce.trustAsResourceUrl(vm.PRICING_PAGE_STRING + '?plan_id=' + PlanStore.get('orgPlan').name);
  }
  else {
    vm.PRICING_PAGE = $sce.trustAsResourceUrl(vm.PRICING_PAGE_STRING);
  }

  vm.showDialog = false;
  vm.show = false;
  vm.view;
  vm.loading = false;
  vm.state = $state.current.name;
  vm.checkoutPage = '';
  vm.tryCoupon = false;
  vm.showSpinner = false;
  vm.chosenPlan;

  const AppDialogsStore = Flux.Store.get('AppDialogsStore');
  let opened = false;

  vm.isAdminBilling = IdentityService.isOrganizationBillingAdmin();
  vm.isAdmin = IdentityService.isOrganizationAdmin();

  vm.convertToSubscription = () => {

    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // vm.subscription = PlanStore.get('externalSubscription');
    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow (Dialog)', {
    //   'remaining_days': (new Date(vm.subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm.returnToPlanSelection = () => {

    AnalyticsService.track('[CORE] Subscription', 'Checkout Plan (Back)', {
      'plan_id': vm.chosenPlan,
      'remaining_days': vm.timeLeft,
      'state': $state.current.name,
      'billing_admin': vm.isAdminBilling
    });
    AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm.selectSubscribePlan = () => {

    const reqPlan = vm.chosenPlan;

    AnalyticsService.track('[CORE] Subscription', 'Checkout Plan', {
      'plan_id': reqPlan,
      'state': $state.current.name,
      'remaining_days': vm.timeLeft,
      'billing_admin': vm.isAdminBilling
    });

    if (vm.isAdminBilling) {
      AppDialogsActions.GetCheckoutPage.dispatch(reqPlan);

    }
    else {
      vm.showDialog = false;
      vm.show = false;
      $timeout(() => {

        AppDialogsActions.InsufficientSubscriptionPrivileges.dispatch();
      }, 100);

    }
  };

  const getWebhookCallback = (event) => {

    try {
      const messageObj = JSON.parse(event.data);
      if (messageObj.hasOwnProperty('skycatch')) {
        // skycatch.com message
        // plan selected from iframe
        if (messageObj.hasOwnProperty('onload')){
          // iframe loaded
        }
        else {
          vm.chosenPlan = messageObj.plan_id;
          if(opened) {
            AnalyticsService.track('[CORE] Subscription', 'Click Plan', {
              'plan_id': vm.chosenPlan,
              'state': $state.current.name,
              'remaining_days': vm.timeLeft,
              'billing_admin': vm.isAdminBilling
            });
          }
          opened = true;
        }

      }
      else {
        // chargebee message
        const contentContainer = angular.element(document.querySelector('#checkoutContentContainer'));
        const pageContainer = angular.element(document.querySelector('#checkoutPageContainer'));
        // This logic was taken from https://js.chargebee.com/v1/chargebee.js
        // I'm not sure why they chose to do it like this, but I'm keeping it like that in the
        // event that this was done on purpose.
        if (messageObj.hasOwnProperty('onload')) {
          vm.showSpinner = false;
          if ($window.outerWidth > 421) {

            contentContainer.css('height', messageObj.height + 50 + 'px');
          }
          else {
            contentContainer.css('height','82%');
            contentContainer.css('overflow','scroll');
            pageContainer.css('overflow', 'scroll');
          }
        }
        else {
          if (messageObj.hasOwnProperty('resize')) {
            if ($window.outerWidth > 421) {
              contentContainer.css('height', messageObj.height + 50 + 'px');
            }
            else {
              contentContainer.css('height','82%');
            }
          }
          else {
            if (messageObj.hasOwnProperty('onSubmit')) {
              vm.loading = true;
            }
            else {
              if (messageObj.hasOwnProperty('success')) {
                vm.loading = true;
                AnalyticsService.track('[CORE] Subscription', 'Activated', {
                  'plan_id': AppDialogsStore.get('plan_id'),
                  'state': $state.current.name,
                  'remaining_days': vm.timeLeft
                });
                AppDialogsActions.GetSuccessfulSignup.dispatch();
              }
              else {
                if (messageObj.hasOwnProperty('cancel')) {
                  vm.loading = false;
                  AnalyticsService.track('[CORE] Subscription', 'Checkout Plan (Cancel)', {
                    'plan_id': AppDialogsStore.get('plan_id'),
                    'state': $state.current.name,
                    'remaining_days': vm.timeLeft
                  });
                  vm.closeModal();
                }
                else {
                  if (messageObj.hasOwnProperty('error')) {
                    vm.loading = false;
                  }
                }
              }
            }
          }
        }
        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
          $scope.$apply();
        }
      }
    }
    catch (err) {
      // Webhook not intended for Chargebee
    }
  };

  const subscribeResponseEmbedHandler = (url) => {

    if (url) {
      vm.checkoutPage = $sce.trustAsResourceUrl(url + '#' + $location.absUrl());
    }
  };

  vm.couponAttempt = () => {

    vm.tryCoupon = true;
    AnalyticsService.track('[CORE] Subscription', 'Coupon Dialog', {
      'plan_id': AppDialogsStore.get('plan_id'),
      'state': $state.current.name,
      'remaining_days': vm.timeLeft
    });
  };

  vm.returnToCheckout = () => {

    if (vm.couponCode) {
      AnalyticsService.track('[CORE] Subscription', 'Applied Coupon', {
        'plan_id': AppDialogsStore.get('plan_id'),
        'coupon': vm.couponCode,
        'state': $state.current.name,
        'remaining_days': vm.timeLeft
      });
      AppDialogsActions.GetCheckoutPage.dispatch(AppDialogsStore.get('plan_id'), vm.couponCode);
    }
    vm.couponCode = undefined;
    vm.tryCoupon = false;
  };

  /**
   * Navigation Functions
   *
   */

  vm.goToBilling = () => {

    vm.loading = true;
    if (vm.isAdmin) {
      $state.go('settings.organization.billing');
    }
    else {
      $state.go('settings.myProfile');
    }
  };

  vm.goToSettings = () => {

    vm.loading = true;
    $state.go('settings.myProfile');
  };


  vm.closeModal = () => {

    vm.showDialog = false;
    vm.show = false;
    vm.loading = false;
    vm.view = null;
    vm.showSpinner = false;

    // Due to manually calling this method
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
  };

  vm.closeModalSubscription = () => {

    AnalyticsService.track('[CORE] Subscription', 'View Plans (Cancel)', {
      'view': vm.view,
      'state': $state.current.name,
      'remaining_days': vm.timeLeft,
      'billing_admin': vm.isAdminBilling
    });
    vm.showDialog = false;
    vm.show = false;
    vm.loading = false;
    vm.view = null;
    vm.showSpinner = false;
    vm.checkoutPage = '';
    vm.siteToDelete = '';
    vm.tryCoupon = false;
    opened = false;
    // Due to manually calling this method
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
  };

  vm.openDialog = () => {

    vm.state = $state.current.name;
    vm.showSpinner = true;
    vm.projectPlan = PlanStore.get('current');
    vm.subscription = PlanStore.get('externalSubscription');
    vm.siteToDelete = AppDialogsStore.get('siteToDelete');
    vm.view = AppDialogsStore.get('view');

    if (vm.view === 'checkoutSubscription') {
      subscribeResponseEmbedHandler(AppDialogsStore.get('checkoutPage'));
    }
    vm.show = true;
  };

  vm.hideDialog = () => {

    vm.show = false;
  };

  vm.handlePlanChanged = () => {

    vm.subscription = PlanStore.get('externalSubscription');
    vm.plan = PlanStore.get('externalPlan');
    vm.loading = false;
    vm.timeLeft = vm.subscription ? (new Date(vm.subscription.trial_end) - new Date() / 1000 ) / (60 * 60 * 24) : -1;
  };

  vm.deleteSite = () => {

    const siteToDeleteId = vm.siteToDelete.id;

    vm.closeModal();

    if (!siteToDeleteId) {
      return;
    }

    SiteActions.DeleteSite.dispatch(siteToDeleteId, vm.siteToDelete);
  };

  vm._handleSiteDeleteError = () => {

    SaturnGrowl.newGrowl('Your changes couldn’t be saved. Please contact your organization admin or support@skycatch.com if the problem persists.', {
      id: 'site-update-error',
      type: 'alert',
      time: -1
    });

  };

  $window.addEventListener('message', getWebhookCallback, false);

  $scope.$on('$destroy', () => {

    $window.removeEventListener('message', getWebhookCallback);
  });

  /////////////////////////////////////////////

  AppDialogsStore.on(AppDialogsStore.Events.CloseDialog, vm.closeModal.bind(vm), $scope);
  AppDialogsStore.on(AppDialogsStore.Events.OpenDialog, vm.openDialog.bind(vm), $scope);
  PlanStore.on(PlanStore.Events.Changed, vm.handlePlanChanged.bind(vm), $scope);
  SiteStore.on(SiteStore.Events.SiteDeleteError, vm._handleSiteDeleteError.bind(vm));
};

AppDialogsController.$inject = [
  '$scope', '$rootScope', '$window', '$state', '$sce', '$timeout', '$location', 'sbFlux', 'SaturnGrowl',
  'AppDialogsActions', 'SiteStore', 'SiteActions', 'IdentityService', 'AnalyticsService'
];
module.exports = AppDialogsController;



// WEBPACK FOOTER //
// ./src/app/dialogs/AppDialogsController.js